import { BarChart3, BellRing, Bot, CalendarDays, CheckSquare, FileText, Wrench, CreditCard, Inbox, Webhook, Workflow, Zap, FileClock, Kanban, LayoutDashboard, ListChecks, MessageSquare, Phone, PhoneCall, Settings, Users, UsersRound } from 'lucide-react';
import type { NavGroup } from '@ui/components/layout/Shell';

export const ORG_NAV: NavGroup[] = [
  { group: '', items: [{ to: '/', label: 'Home', icon: LayoutDashboard, keywords: 'dashboard overview' }] },
  {
    group: 'Outreach',
    items: [
      { to: '/campaigns', label: 'Campaigns', icon: ListChecks, keywords: 'dialer bulk' },
      { to: '/calls', label: 'Calls', icon: PhoneCall, keywords: 'history transcript recording' },
      { to: '/reports', label: 'Reports', icon: BarChart3, keywords: 'reports export csv excel xlsx download leads interested callback outcomes campaign performance analytics crm revenue conversion' },
      { to: '/messages', label: 'Messages', icon: MessageSquare, keywords: 'sms email templates' },
      { to: '/contacts', label: 'Contacts', icon: UsersRound, keywords: 'leads import csv lists dnc' }
    ]
  },
  {
    group: 'Configure',
    items: [
      { to: '/agents', label: 'AI agents', icon: Bot, keywords: 'voice script knowledge' },
      { to: '/numbers', label: 'Phone numbers', icon: Phone, keywords: 'inbound' }
    ]
  },
  {
    group: 'Account',
    items: [
      { to: '/billing', label: 'Billing', icon: CreditCard, keywords: 'wallet balance recharge top-up minutes card payment' },
      { to: '/team', label: 'Team', icon: Users, keywords: 'members invite roles' },
      { to: '/audit', label: 'Audit log', icon: FileClock, keywords: 'history changes ip' },
      { to: '/settings', label: 'Settings', icon: Settings, keywords: 'profile timezone' }
    ]
  }
];

/** Shown only to organizations with the CRM module on (inserted after Home). */
export const CRM_NAV: NavGroup = {
  group: 'CRM',
  items: [
    { to: '/crm/pipeline', label: 'Pipeline', icon: Kanban, keywords: 'crm deals opportunities sales board kanban' },
    { to: '/crm/tasks', label: 'Tasks', icon: CheckSquare, keywords: 'crm follow-up todo reminders' },
    { to: '/crm/sources', label: 'Lead sources', icon: Webhook, keywords: 'crm leads website form api webhook leadgen intake' },
    { to: '/crm/leads', label: 'Lead log', icon: Inbox, keywords: 'crm incoming leads intake failed duplicate' },
    { to: '/crm/playbooks', label: 'Playbooks', icon: Workflow, keywords: 'crm automation steps call text email new lead' },
    { to: '/crm/automations', label: 'Automations', icon: Zap, keywords: 'crm after call outcome no answer interested rules' },
    { to: '/crm/approvals', label: 'Approvals', icon: BellRing, keywords: 'crm review approve pending send' }
  ]
};

/** Shown only with the Bookings (ERP) module on. */
export const ERP_NAV: NavGroup = {
  group: 'Operations',
  items: [
    { to: '/erp/bookings', label: 'Bookings', icon: CalendarDays, keywords: 'erp calendar appointments jobs schedule' },
    { to: '/erp/invoices', label: 'Invoices', icon: FileText, keywords: 'erp invoices bills payments tax hst outstanding' },
    { to: '/erp/settings', label: 'Services & staff', icon: Wrench, keywords: 'erp services prices staff branches hours reminders' }
  ]
};

export const orgNav = (modules?: { crm?: boolean; erp?: boolean }): NavGroup[] =>
  modules?.crm ? [ORG_NAV[0]!, CRM_NAV, ...(modules.erp ? [ERP_NAV] : []), ...ORG_NAV.slice(1)] : ORG_NAV;
